import produce from 'immer'
import { createAsyncObject } from '@jarvis.oddle/core/tools/redux/action'
import { updateForAsyncRequest, updateForAsyncSuccess, updateForAsyncFailure } from '@jarvis.oddle/core/tools/redux/reducer'
import * as CC from 'redux-store/common/constants'
import * as C from './constants'

export const initialState = createAsyncObject([])

export const reducers = (state = initialState, action) => produce(state, draftState => {
  switch (action.type) {
    case CC.CHANGE_CART_NAME: draftState.fetched = false; break
    case C.GET_AVAILABLE_PROMO_REQUEST: updateForAsyncRequest(draftState); break
    case C.GET_AVAILABLE_PROMO_SUCCESS: {
      // Promotion with higer value of promoOrder should appear first.
      const promotions = (action.payload.promotions || []).sort((p1, p2) => p1.promoOrder > p2.promoOrder ? -1 : 1)
      updateForAsyncSuccess(promotions)(draftState)
      break
    }
    case C.GET_AVAILABLE_PROMO_FAILURE: updateForAsyncFailure(action)(draftState); break
  }
})
